//
//
//
//
//
//
//
//
//
//
//

import Icon from '../../../icons'
export default{
  components: {
    Icon
  },
  props: {
    iconName: String,
    tabTitle: String
  },
  data() {
    return {
      selected: false
    }
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/components/views/common/xy-tabbar-item.vue